export default __webpack_public_path__ + "static/thumbnail-3f99100f0fe911670a26fe41adf2cf89.png";